import { Link } from "react-router-dom";
import { useCompanyFlow } from "@/hooks/useCompanyFlow";
import LogoFooter from "@/assets/imgs/logo.png";

export const Footer = () => {
  const { getCompanyRoute } = useCompanyFlow();
  return (
    // <div className="container-fluid" style={{paddingTop:'40px', backgroundColor:"#F6F9E9"}}>
    <footer>
      <div
        className="row"
        style={{ padding: "40px", backgroundColor: "#F6F9E9" }}
      >
        {/* <div className="col"></div> */}
        <div className="col-12 col-md-3 col-lg-3">
          <img
            className="img-fluid"
            src={LogoFooter}
            alt="Openmatic"
            style={{ marginLeft: "-70px" }}
          />
          <p className="text-black montserrat-regular"> </p>
        </div>
        <div className="col"></div>
        <div className="col"></div>
        <div className="col">
          <p className="fw-bold text-black montserrat-ultrabold"></p>
          <ul
            className="montserrat-regular text-black"
            style={{
              listStyleType: "none",
              paddingLeft: "0",
              fontSize: "small",
            }}
          >
            <li>{/* <a href="/about-us">Quienes somos</a> */}</li>
            <li>{/* <a href="">Politicas de privacidad</a> */}</li>
          </ul>
        </div>
        <div className="col">
          {/* <p className="fw-bold text-black montserrat-ultrabold">Nosotros </p> */}
          <ul
            className="montserrat-regular text-black "
            style={{
              listStyleType: "none",
              paddingLeft: "0",
              fontSize: "small",
            }}
          >
            {/* <li>
                <a href="/about-us">Quienes somos</a>
              </li>
              <li>
                <a href="/privacy">Politicas de privacidad</a>
              </li>
              <li></li> */}
          </ul>
        </div>
        <div className="col">
          <ul
            className="montserrat-regular text-black"
            style={{
              listStyleType: "none",
              paddingLeft: "0",
              fontSize: "small",
            }}
          >
            <li>
               <Link className="footer-link-color" to={getCompanyRoute("about-us")}>
                Quienes somos
              </Link>
            </li>
            <li>
              <a
                className="footer-link-color"
                href="https://openmaticmarket.com/Politica_Privacidad_OpenMatic.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Politicas de privacidad
              </a>
            </li>
            <li>
              <Link className="footer-link-color" to={getCompanyRoute("contact")}>
                ¡Contáctanos!
              </Link>
            </li>
            <li>
              <i className="bi bi-envelope-fill"></i>
            </li>
          </ul>
        </div>
      </div>
    </footer>
    // </div>
  );
};
